<template lang="pug" src="./cadastrarSenha.pug"></template>

<script>
import idioma from '../../../../build/language/index.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'CadastrarSenha',

  data () {
    return {
      username: null,
      pass: null,
      confirmPass: null,
      chave: null,
      success: false,
      abrirIdiomas: false,
      senhaDiferente: false,
      campoUsernamaVazio: false,
      campoUsernameInvalido: false,
      campoPassVazio: false,
      campoConfirmPassVazio: false,
      disableCreateButton: false,
      idiomaPng: require('../../../assets/login/img/idioma.png'),
      logoEqualsLoginPng: require('../../../assets/logos_equals/logo_banking.png'),
      fecharPng: require('../../../assets/login/img/fechar.png'),
      idiomaAtivoPng: require('../../../assets/login/img/idioma-ativo.png'),
      logadoOkPng: require('../../../assets/login/img/logado-ok.png')
    }
  },

  watch: {
    username () {
      if (this.username && this.username.length > 0) {
        this.campoUsernamaVazio = false
        this.campoUsernameInvalido = false
        document.getElementById('nome').style.borderBottom = '2px solid #ffffff'
      }
    },
    pass () {
      if (this.pass && this.pass.length > 0) {
        this.campoPassVazio = false
        document.querySelector('#senha').style.borderBottom = '2px solid #ffffff'
      }
    },
    confirmPass () {
      if (this.confirmPass && this.confirmPass.length > 0) {
        this.campoConfirmPassVazio = false
        this.senhaDiferente = false
        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #ffffff'
      }
    }
  },

  methods: {
    escolherIdioma () {
      this.abrirIdiomas = true
    },

    fecharEscolherIdioma () {
      this.abrirIdiomas = false
    },

    trocarIdioma (language) {
      idioma.changeLanguage(language)

      $('div.btn-group').find('.btn-ativo').removeClass('btn-ativo')

      switch (language) {
        case 'pt':
          $('.btn-pt').addClass('btn-ativo')
          break
        case 'in':
          $('.btn-in').addClass('btn-ativo')
          break
        case 'es':
          $('.btn-es').addClass('btn-ativo')
          break
        default:
          break
      }
    },

    cadastrar (event) {
      event.preventDefault()
      if (this.validateForm()) {
        this.disableCreateButton = true
        this.chave = this.$route.query.hash
        if (location.pathname === PATHS.NEW_PASSWORD) {
          this.$store.dispatch('registerPassword', {
            username: this.username,
            password: this.pass,
            confirmPassword: this.confirmPass,
            key: this.chave
          }).then((response) => {
            this.$root.$refs.notification.success('login.sucesso.cadastrarSenha')
            this.disableCreateButton = false
            this.$router.push(PATHS.LOGIN)
          }).catch((error) => {
            this.disableCreateButton = false
            this.$root.$refs.notification.error(error.message)
          })
        } else {
          this.$store.dispatch('registerRecoverPassword', {
            username: this.username,
            password: this.pass,
            confirmPassword: this.confirmPass,
            key: this.chave
          }).then((response) => {
            this.disableCreateButton = false
            this.$root.$refs.notification.success('login.sucesso.alterarSenha')
            this.$router.push(PATHS.LOGIN)
          }).catch((error) => {
            this.disableCreateButton = false
            this.$root.$refs.notification.error(error.message)
          })
        }
      }
    },

    validateForm () {
      // Não pode fazer o retorno direto das funções de validação para
      // garantir que ambos o campos do form sejam validados na ação.
      let isValidForm = this.verificarCamposVazios()
      let isSamePass = this.verificarSenhasIguais()
      return isValidForm && isSamePass
    },

    validateEmail () {
      return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(this.username)
    },

    verificarCamposVazios () {
      let isValid = true
      this.campoUsernamaVazio = false
      this.campoPassVazio = false
      this.campoConfirmPassVazio = false
      this.campoUsernameInvalido = false

      if (this.username == null || this.username === undefined || this.username === '') {
        this.campoUsernamaVazio = true
        document.querySelector('#nome').style.borderBottom = '2px solid #c65b55'
        isValid = false
      } else if (!this.validateEmail()) {
        this.campoUsernameInvalido = true
        document.querySelector('#nome').style.borderBottom = '2px solid #c65b55'
        isValid = false
      }

      if (this.pass == null || this.pass === undefined || this.pass === '') {
        this.campoPassVazio = true
        document.querySelector('#senha').style.borderBottom = '2px solid #c65b55'
        isValid = false
      }

      if (this.confirmPass == null || this.confirmPass === undefined || this.confirmPass === '') {
        this.campoConfirmPassVazio = true
        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #c65b55'
        isValid = false
      }

      return isValid
    },

    verificarSenhasIguais () {
      if (this.pass === this.confirmPass) {
        return true
      } else {
        this.senhaDiferente = true
        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #c65b55'
        return false
      }
    },

    carregarImagem (nomeImagem) {
      var idiomaImagem = idioma.getCookieByName('language')
      return require('../../../assets/login/img/' + nomeImagem + idiomaImagem + '.png')
    }
  },

  mounted () {
    this.$store.dispatch('logout')
    idioma.changeLanguage(idioma.getCookieByName('language'))

    // Deixa ativo o botão do idioma selecionado.
    switch (idioma.getCookieByName('language')) {
      case 'pt':
        $('.btn-pt').addClass('btn-ativo')
        break
      case 'in':
        $('.btn-in').addClass('btn-ativo')
        break
      case 'es':
        $('.btn-es').addClass('btn-ativo')
        break
      default:
        break
    }
  }
}
</script>

<style scoped>
@media (min-width: 420px) {
  .recaptcha-form {
    margin: auto;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .recaptcha-form {
    margin: auto;
    width: 64%;
  }
}

.bg-tela-login:after {
  content: "";
  position: fixed;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  left: 0;
  right: 0;
  height: 8px;
}

.bg-tela-login:after {
  bottom: 0;
}

.bg-tela-login {
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #223768;
  background: #223768;
  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);
  background: -o-linear-gradient(right, #223768, #00C3BE);
  background: -moz-linear-gradient(right, #223768, #00C3BE);
  background: linear-gradient(to right, #223768, #00C3BE);
}

.inicial-wrap {
  font-family: 'Inter', sans-serif;
  max-width: 650px;
  margin: 50px auto;
  -webkit-transition: -webkit-transform 300ms ease-in-out;
  transition: -webkit-transform 300ms ease-in-out;
  transition: transform 300ms ease-in-out;
  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;
}

.inicial-bodies {
  font-family: 'Inter', sans-serif;
  text-align: center;
  position: relative;
  -webkit-perspective: 1000px;
  perspective: 1000px;
}

button.button {
  font-family: 'Inter', sans-serif;
  background-color: rgba(174, 223, 120, 1);
  font-size: 20px;
  cursor: pointer;
  margin-top: 60px !important;
  color: rgba(28, 59, 101, 1);
  text-transform: uppercase;
  width: 100%;
  height: 60px;
  border: none;
}

button.button:hover {
  background-color: rgba(174, 223, 120, 1);
  color: rgba(28, 59, 101, 1);
  border: none;
}

.button i {
  font-weight: normal;
  font-size: 24px;
  margin-right: 5px;
}

/*Tela de boas vindas*/

.boas-vindas-tit {
  text-align: center;
  font-size: 50px;
  color: rgba(122, 203, 231, 1);
}

.boas-vindas-txt {
  text-align: center;
  padding: 50px 145px 50px 145px;
  font-size: 25px;
  color: rgba(255, 255, 255, 1);
}

.boas-vindas-txt-bottom {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: rgba(122, 203, 231, 1);
}

.inicial-body {
  background: #005E78;
  padding: 40px 0px 0px 0px;
  margin-bottom: 50px;
  display: none;
  box-sizing: border-box;
  width: 100%;
}

.inicial-body2 {
  border: 2px solid rgba(255, 255, 255, 1);
  margin-bottom: 50px;
  display: none;
  width: 100%;
}

.inicial-body3 {
  border: 2px solid rgba(255, 255, 255, 1);
  margin-bottom: 50px;
  display: none;
  width: 100%;
}

.formulario-login-topo {
  height: 85px;
  background-color: #FFF;
}

button.btn-idioma {
  background: #fff;
  float: right;
  height: 100%;
  padding: 2%;
  border: none;
}

button.btn-idioma:hover {
  background: transparent;
  border: none;
}

button.btn-idioma:active {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.escolhaIdiomas {
  background: rgba(133, 186, 202, 1);
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(left, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* Standard syntax */
  height: 50px;
  z-index: 2;
}

.escolhaIdiomas p {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  color: rgba(28, 59, 101, 1);
  padding: 15px;
  font-weight: bold;
  vertical-align: middle;
}

button.btn-escolher-idioma {
  font-family: 'Inter', sans-serif;
  border: none;
  font-size: 15px;
  background-color: transparent;
  padding: 14px 10px 15px 10px;
  color: rgba(255, 255, 255, 1);
}

button.btn-escolher-idioma.btn-ativo {
  border: none;
  background-color: rgba(224, 239, 244, 1);
  padding: 14px 10px 10px 10px;
  border-bottom: 5px solid rgba(28, 59, 101, 1);
  color: rgba(28, 59, 101, 1);
}

button.btn-escolher-idioma:hover {
  border: none;
  background-color: rgba(224, 239, 244, 1);
  padding: 14px 10px 10px 10px;
  border-bottom: 5px solid rgba(28, 59, 101, 1);
  color: rgba(28, 59, 101, 1);
}

button.btn-fechar-escolher-idioma {
  background-color: transparent;
  padding: 0px;
  margin: 0px 6px 0px 25px!important;
  border: none;
}

button.btn-fechar-escolher-idioma:hover {
  background-color: transparent;
  border: none;
}

button.btn-fechar-escolher-idioma:active {
  background-color: transparent;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

button.btn-esqueceu-senha {
  background-color: transparent;
  border: none;
  z-index: 2;
  position: absolute;
  height: 60px;
  width: 60px;
  right: 0;
  text-align: center;
  padding: 0px;
}

button.btn-esqueceu-senha:hover {
  background-color: transparent;
  border: none;
}

button.btn-esqueceu-senha:active {
  background-color: transparent;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.logo-equals {
  height: 100%;
  padding: 20px;
}

.formulario-login {
  padding: 80px 125px 70px 125px;
  box-sizing: border-box;
  width: 100%;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #fff !important;
}

.formulario-login input {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 0px!important;
  border: none;
  border-bottom: 2px solid rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  height: 60px;
}

.formulario-login input:focus {
  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;
  box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;
}

.formulario-login input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 1)!important;
}

.formulario-login input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 1)!important;
}

.formulario-login input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 1)!important;
}

.formulario-login input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 1)!important;
}

button.button-login {
  font-family: 'Inter', sans-serif;
  background-color: rgba(28, 59, 101, 1);
  bottom: 0;
  font-size: 20px;
  cursor: pointer;
  color: rgba(255, 255, 255, 1)!important;
  text-transform: uppercase;
  width: 100%;
  height: 60px;
  border: none;
}

button.button-login:hover {
  background-color: rgba(28, 59, 101, 1);
  color: rgba(255, 255, 255, 1)!important;
  border: none;
}

button.button-login:active {
  background-color: rgba(28, 59, 101, 1);
  color: rgba(255, 255, 255, 1)!important;
  border: none;
}

button.button-login:disabled {
  background-color: rgba(28, 59, 101, 1);
  cursor: progress;
  color: #FFF;
  border: none;
}

/*Captcha*/

.captcha {
  font-family: 'Inter', sans-serif;
  background-color: #FFF;
  padding: 20px 10px;
}

.captcha p {
  width: 100%;
  font-size: 15px;
  margin-top: 10px;
}

#mainCaptcha {
  width: 90%;
  background-color: transparent;
  color: black;
  text-align: center;
  padding: 0px;
}

.text-center {
  text-align: center;
}

button.btn-refresh-catpcha {
  width: 10%;
  background-color: transparent;
  padding: 0px;
  border: none;
}

button.btn-refresh-catpcha:hover {
  background-color: transparent;
  border: none;
}

button.btn-refresh-catpcha:active {
  background-color: transparent;
  border: none;
}

input.captcha-recuperar-senha {
  padding: 8px;
  width: 100%;
  /* background-color: rgba(95, 169, 192, 1); */
  border-radius: 0px!important;
  border: none;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
}

.g-recaptcha {
  display: inline-block;
}

input.captcha-recuperar-senha::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 1)!important;
}

input.captcha-recuperar-senha:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 1)!important;
}

input.captcha-recuperar-senha::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 1)!important;
}

input.captcha-recuperar-senha:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 1)!important;
}

button.button2 {
  margin-top: 30px!important;
  background-color: transparent;
  border: none;
  color: rgba(28, 59, 101, 1);
  padding: 0px;
}

button.button2:hover {
  background-color: transparent;
  border: none;
  color: rgba(28, 59, 101, 1);
}

button.button2:active {
  background-color: transparent;
  border: none;
  color: rgba(28, 59, 101, 1);
  background-color: transparent;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

button.button2 span {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  margin-left: 8px;
  font-weight: bold;
}

/*Tela logado*/

.logado {
  font-family: 'Inter', sans-serif;
  background-color: rgba(147, 191, 98, 1);
  color: rgba(255, 255, 255, 1);
}

.logado-ok {
  font-size: 50px;
  margin: 30px 0px 10px 0px;
}

.bem-vindo {
  font-size: 20px;
  text-transform: uppercase;
}

.img-bottom {

  height: 60px;
  /*max-width: 650px;*/
  vertical-align: middle;
  margin-bottom: 30px;
  /*position: absolute;*/
}

/*Login com erro*/

.erro-login {
  color: rgba(106, 34, 35, 1);
  margin-top: 5px;
  font-size: 14px;
  font-style: italic;
}

.inicial-body.is-showing {
  display: block;
}

.inicial-body2.is-showing {
  display: block;
}

.inicial-body3.is-showing {
  display: block;
}

.animate-out {
  -webkit-animation: out 600ms ease-in-out;
  animation: out 600ms ease-in-out;
}

.animate-in {
  -webkit-animation: in 400ms ease-in-out;
  animation: in 400ms ease-in-out;
  display: block;
}

.animate-up {
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
}

.form-control {
  font-family: 'Inter', sans-serif;
}

html,
body {
  height: 100%;
}

body {
  overflow: auto;
}

.vertical-center {
  min-height: 100%;
  min-height: 99vh;

  /* Make it a flex container */
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  /* Align the bootstrap's container vertically */
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  width: 100%;

  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}

.jumbotron.vertical-center {
  margin-bottom: 0;
}

#loginInput {
  padding-left: 50px;
}

#loginSenha {
  padding-left: 50px;
}

.inicial-wrap.px-0.img-bottom div {
  padding-bottom: 15px;
}

.formulario-login .form-group>img {
  background-color: transparent;
  border: none;
  position: absolute;
  left: 0;
  text-align: center;
  padding: 15px;
}

@-webkit-keyframes out {
  0% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
  100% {
    opacity: 0;
    -webkit-transform: rotateY(-90deg);
    transform: rotateY(-90deg);
  }
}

@keyframes out {
  0% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
  100% {
    opacity: 0;
    -webkit-transform: rotateY(-90deg);
    transform: rotateY(-90deg);
  }
}

@-webkit-keyframes in {
  0% {
    opacity: 0;
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
  }
  100% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
}

@keyframes in {
  0% {
    opacity: 0;
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
  }
  100% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// CadastrarSenha.vue?abd82704